import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="container mx-auto py-1 md:left-20 bg-white dark:bg-dark-mode">
      <p className="text-xs text-center text-dark-content dark:text-light-content w-full">
        Designed and Coded by{" "}
        <Link className="font-medium" to="https://ritiksingh11661.vercel.app/" target="_blank" rel="noreferrer noopener">Ritik Singh</Link>{" "}with
        <span className="text-gradient font-medium"> Love</span> &
        <span className="text-gradient font-medium"> Coffee</span>
      </p>
    </footer>
  );
}
export default Footer;
